<template>
    <div
        class="w-[400px] h-[304px] px-2 py-3 bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 justify-start items-start inline-flex flex-col absolute inset-y-full left-[50x] mt-3 z-10 overflow-auto"
        v-if="searches.length"
        ref="recentSearches"
    >
        <div class="w-full flex flex-col gap-2">
            <div
                v-for="(search, index) in searches"
                :key="search.id"
                class="w-full flex flex-col gap-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 p-2 rounded"
                @click="handleSearchSelect(search)"
                @keyup.enter="handleSearchSelect(search)"
                tabindex="0"
                @keyup.tab="$emit('tabAway')"
            >
                <div class="flex items-center gap-2">
                    <div class="w-5 h-5 text-gray-500">
                        <i class="fa-regular fa-clock"></i>
                    </div>
                    <slot :search="search"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { ref, watch } from 'vue';
import { useHotelsStore } from '@/store/hotels';
import { useCalendarStore } from '@/store/calendar';

export default {
    props: {
        searches: {
            type: Array,
            required: true,
        },
    },

    emits: ['searchSelected', 'tabAway'],

    setup(props, { emit }) {
        const hotelsStore = useHotelsStore();
        const calendarStore = useCalendarStore();
        const focusedIndex = ref(0);
        const searchRefs = ref([]);

        watch(focusedIndex, (newIndex) => {
            if (searchRefs.value[newIndex]) {
                searchRefs.value[newIndex].focus();
            }
        });

        // const setRef = (el, index) => {
        //     searchRefs.value[index] = el;
        // };

        const handleSearchSelect = (search) => {
            emit('searchSelected', search);
        };

        const formatDate = (date) => {
            return dayjs(date).format('MMM D');
        };

        return {
            formatDate,
            handleSearchSelect,
        };
    },
};
</script>
